import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";

export const Route = createFileRoute("/")({
  head: () => {
    const title = "MNRE | Luxury Real Estate Mumbai | Mohnish Nagpal Advisory";
    const description = "Premier luxury real estate advisory in Mumbai. Search verified apartments, penthouses, and BKC commercial properties across Bandra West, Khar West, Santacruz, and Juhu.";
    const canonicalUrl = "https://mnre.in/";
    const ogImage = "https://mnre.in/blog-covers/mumbai-sealink-skyline.jpg";

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonicalUrl },
        { property: "og:image", content: ogImage },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: ogImage },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: Index,
});
